'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n  span > span {\n    font-size: 14px;\n  }\n  \n  div > div > div > div > div {\n    padding: 5px 5px 5px 10px;\n  }\n  \n  div > div > div > div {\n    font-size: 13px;\n  }\n'], ['\n  span > span {\n    font-size: 14px;\n  }\n  \n  div > div > div > div > div {\n    padding: 5px 5px 5px 10px;\n  }\n  \n  div > div > div > div {\n    font-size: 13px;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactGooglePlacesSuggest = require('react-google-places-suggest');

var _reactGooglePlacesSuggest2 = _interopRequireDefault(_reactGooglePlacesSuggest);

var _TextField = require('../TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var ReactGooglePlacesSuggestStyled = _styledComponents2.default.div(_templateObject);

var PlaceSuggestField = function (_React$Component) {
    _inherits(PlaceSuggestField, _React$Component);

    function PlaceSuggestField() {
        var _temp, _this, _ret;

        _classCallCheck(this, PlaceSuggestField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            search: "",
            value: ""
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    PlaceSuggestField.prototype.handleInputChange = function handleInputChange(value) {
        this.setState({ search: value, value: value });
    };

    PlaceSuggestField.prototype.handleSelectSuggest = function handleSelectSuggest(selection) {
        this.setState({ search: "", value: selection.formatted_address });
        this.props.handleSelectSuggest({
            address: selection.formatted_address,
            lat: selection.geometry.location.lat(),
            lng: selection.geometry.location.lng()
        });
    };

    PlaceSuggestField.prototype.render = function render() {
        var _this2 = this;

        var _state = this.state,
            search = _state.search,
            value = _state.value;

        return _react2.default.createElement(
            ReactGooglePlacesSuggestStyled,
            { className: 'google-places-suggest' },
            _react2.default.createElement(
                _reactGooglePlacesSuggest2.default,
                {
                    autocompletionRequest: { input: search },
                    googleMaps: this.props.googleMaps,
                    onSelectSuggest: function onSelectSuggest(selection) {
                        return _this2.handleSelectSuggest(selection);
                    }
                },
                _react2.default.createElement(_TextField2.default, { value: value,
                    label: 'Enter your address',
                    onChangeHandler: function onChangeHandler(input) {
                        return _this2.handleInputChange(input);
                    },
                    error: this.props.error
                })
            )
        );
    };

    return PlaceSuggestField;
}(_react2.default.Component);

PlaceSuggestField.propTypes = {
    googleMaps: _propTypes2.default.object.isRequired,
    handleSelectSuggest: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string
};

exports.default = PlaceSuggestField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/PlaceSuggestField/index.js
// module id = 793
// module chunks = 0